import { MoveStruct, normalizeMoveArguments } from "../utils/index.mjs";
import { bcs } from "@safecoin/safe/bcs";
//#region src/contracts/kiosk/kiosk_lock_rule.ts
/**************************************************************
* THIS FILE IS GENERATED AND SHOULD NOT BE MANUALLY MODIFIED *
**************************************************************/
/**
* Description: This module defines a Rule which forces buyers to put the purchased
* item into the Kiosk and lock it. The most common use case for the Rule is making
* sure an item never leaves Kiosks and has policies enforced on every transfer.
*
* Configuration:
*
* - None
*
* Use cases:
*
* - Enforcing policies on every trade
* - Making sure an item never leaves the Kiosk / certain ecosystem
*
* Notes:
*
* - "locking" mechanic disallows the `kiosk::take` function and forces the owner
*   to use `list` or `list_with_purchase_cap` methods if they wish to move the
*   item somewhere else.
*/
const $moduleName = "@local-pkg/kiosk::kiosk_lock_rule";
new MoveStruct({
	name: `${$moduleName}::Rule`,
	fields: { dummy_field: bcs.bool() }
});
new MoveStruct({
	name: `${$moduleName}::Config`,
	fields: { dummy_field: bcs.bool() }
});
/**
* Creator: Adds a `kiosk_lock_rule` Rule to the `TransferPolicy` forcing buyers to
* lock the item in a Kiosk on purchase.
*/
function add(options) {
	const packageAddress = options.package ?? "@local-pkg/kiosk";
	const argumentsTypes = [null, null];
	const parameterNames = ["policy", "cap"];
	return (tx) => tx.moveCall({
		package: packageAddress,
		module: "kiosk_lock_rule",
		function: "add",
		arguments: normalizeMoveArguments(options.arguments, argumentsTypes, parameterNames),
		typeArguments: options.typeArguments
	});
}
/**
* Buyer: Prove the item was locked in the Kiosk to get the receipt and unblock the
* transfer request confirmation.
*/
function prove(options) {
	const packageAddress = options.package ?? "@local-pkg/kiosk";
	const argumentsTypes = [null, null];
	const parameterNames = ["request", "kiosk"];
	return (tx) => tx.moveCall({
		package: packageAddress,
		module: "kiosk_lock_rule",
		function: "prove",
		arguments: normalizeMoveArguments(options.arguments, argumentsTypes, parameterNames),
		typeArguments: options.typeArguments
	});
}
//#endregion
export { add, prove };

//# sourceMappingURL=kiosk_lock_rule.mjs.map